<template>
  <div class="like-list-container">
    <div class="like-title">
      <div>收到的点赞</div>
      <div class="close" @click="bindClose">取消</div>
    </div>
    <div class="like-wrap">
      <div class="like-list" v-if="likeList">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getLikeList"
          :immediate-check="false"
        >
          <div class="l-list">
            <div
              class="l-item"
              v-for="(item, index) in likeList"
              :key="index"
              @click.stop="bindJumpUserInfo(item)"
            >
              <div class="l-item-avatar">
                <img class="l-avatar" :src="item.head_img" alt="" />
                <img class="l-flag" src="" alt="" />
              </div>
              <div class="l-item-name">{{ item.truename }}</div>
              <div
                v-if="user && user.unify_id != item.unify_id"
                class="focus-btn"
                :class="{ 'focused-btn': item.is_follow }"
                @click.stop="bindFocus(item)"
                ><img
                  class="add-image"
                  v-if="!item.is_follow"
                  src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/6d58c754186bc97ff92c8a8d45564b80_wh=80_80.webp"
                  alt=""
                /><span>{{ item.is_follow ? '已关注' : '关注' }}</span></div
              >
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        if (this.id) {
          this.initLikeList()
        }
      }
    }
  },
  computed: {
    user() {
      return (
        (this.$store.state.userInfo && this.$store.state.userInfo.user) || null
      )
    }
  },
  data() {
    return {
      page: 1,
      likeList: null,
      loading: false,
      finished: false
    }
  },
  created() {},
  methods: {
    bindClose() {
      this.$emit('close')
    },
    async initLikeList() {
      this.likeList = []
      this.page = 1
      this.finished = false
      if (!this.appToken) {
        this.appToken = await this.$betterwe.getAppToken()
      }
      this.getLikeList()
    },
    async getLikeList() {
      let res = await this.$http
        .getBaseApp('api/v2/Ugc/getLikeList', {
          group_id: this.id,
          page: this.page,
          token: this.appToken
        })
        .catch(() => {
          this.finished = true
        })
      this.loading = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.page++
          if (res.data && res.data.length) {
            if (!this.likeList) {
              this.likeList = res.data || []
            } else {
              this.likeList.push(...res.data)
            }
          } else {
            this.finished = true
          }
        }
      } else {
        this.finished = true
      }
    },
    bindJumpUserInfo(item) {
      let id = item.unify_id
      this.$betterwe.jumpRoute(`/userDetailsPage?id=${id}`)
    },
    async bindFocus(item) {
      let isFollow = item.is_follow ? 0 : 1
      let res = await this.$http
        .postBaseApp('member/appCamp/optionFollow', {
          unify_id: item.unify_id,
          flag: isFollow,
          token:
            'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6NTIyOSwidGltZSI6MTc2ODE4OTQ0MSwicGhvbmUiOiIxODM3MzQxMjY0MCIsImFyZWFDb2RlIjoiODYiLCJjbGllbnRfdHlwZSI6MSwibG9naW5faWQiOiIxMzAwODciLCJpc192aXNpdG9yIjowfQ.bWbSUbwzjywj4NnFOZjPwoNsLgzULx2QqiDdvHXWmgs'
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          item.is_follow = isFollow
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.like-list-container {
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .like-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 18px;
    color: #050b27;

    .close {
      height: 20px;
      padding: 0px 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 14px;
      color: rgba(5, 11, 39, 0.8);
    }
  }

  .like-wrap {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }

  .like-list {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;

    .l-list {
      padding: 30px 0px;

      .l-item {
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        .l-item-avatar {
          position: relative;
          width: 36px;
          height: 36px;
          margin-right: 10px;

          .l-avatar {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
            overflow: hidden;
          }
        }

        .l-item-avatar::after {
          content: '';
          position: absolute;
          right: -5px;
          bottom: 0px;
          width: 12px;
          height: 12px;
          background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/c20dd715ab17536a428d8dedbf84aa04_wh=48_48.webp');
          background-size: 100%;
          background-repeat: no-repeat;
        }

        .l-item-name {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          margin-right: 6px;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;
          font-size: 14px;
          color: #050b27;
        }

        .focus-btn {
          width: 72px;
          height: 28px;
          background: #ffffff;
          border-radius: 14px;
          border: 0.5px solid #050b27;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 12px;
          color: #050b27;

          .add-image {
            width: 10px;
            height: 10px;
            object-fit: contain;
            margin-right: 5px;
            filter: brightness(0);
          }
        }

        .focused-btn {
          opacity: 0.5;
        }
      }

      .l-item:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
